module.exports = __webpack_public_path__ + "img/twitter.60edd440.jpg";